/* eslint-disable react/no-unused-state */
/* eslint-disable react/state-in-constructor */
import React, { Component } from 'react';
import { FeatureFlagsContext } from './feature-flags-context.deprecated';
import { FeatureFlagsHashMap } from '../types';
import FeatureFlagsService from '../feature-flags.service';

type PageComponent = React.ComponentType & {
  getInitialProps(ctx: any): any;
};

interface FeatureFlagsOptions {
  serverUrl: string;
  appName: string;
}

/**
 * @deprecated Use useFeatureFlag instead
 */
export const withFeatureFlagsProvider = (Page: PageComponent, options: FeatureFlagsOptions) =>
  class extends Component {
    public static displayName = `withFeatureFlagsProvider(${Page.displayName ||
      Page.name ||
      'Component'})`;

    public isComponentMounted = false;

    public state: { data: FeatureFlagsHashMap; error: Error | null; loading: boolean } = {
      error: null,
      data: {},
      loading: true,
    };

    public async componentDidMount() {
      this.isComponentMounted = true;
      try {
        const featureFlagsService = new FeatureFlagsService(options.serverUrl);
        await featureFlagsService
          .getBy(options.appName)
          .then((response: any) => {
            if (this.isComponentMounted) {
              this.setState({
                error: null,
                data: response,
                loading: false,
              });
            }
          })
          .catch((error: any) => {
            if (this.isComponentMounted) {
              this.setState({
                error,
                data: {},
                loading: false,
              });
            }
          });
      } catch (e) {
        if (this.isComponentMounted) {
          this.setState({
            error: 'An unexpected error has occurred',
            data: {},
            loading: false,
          });
        }
      }
    }

    public componentWillUnmount() {
      this.isComponentMounted = false;
    }

    static async getInitialProps(ctx: any) {
      const pageProps = Page.getInitialProps && (await Page.getInitialProps(ctx));
      return { ...pageProps };
    }

    public render() {
      return (
        <FeatureFlagsContext.Provider value={this.state}>
          <Page {...this.props} />
        </FeatureFlagsContext.Provider>
      );
    }
  };

export default withFeatureFlagsProvider;
